import React, { useState, useRef, useEffect } from "react";
// import { Box, useTheme, Button } from "@mui/material";
import {
  Box,
  useTheme,
  Button,
  Modal,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
  IconButton,
  // CellEditor,
  // EditIcon,
  // DeleteIcon,
} from "@mui/material";

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

// import { styled } from '@mui/material/styles';

import { DataGrid, GridApi } from "@mui/x-data-grid";

import { useGetYogasQuery, useCreateYogaMutation, useUpdateYogaMutation, useDeleteYogaMutation, useGetLanguageQuery, useGetYogaEmpowerCategoriesQuery } from "state/api";
import { Header } from "components";

// import { useMutation, useQueryClient } from 'react-query';

// Firebase imports

import firebase from '../../../services/firebase';
// import firebase from 'firebase';
import { getAuth, signInAnonymously } from "firebase/auth";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { type } from "@testing-library/user-event/dist/type";

// import {createYoga} from '../../../../../server/controllers/client';
// import {YogaModel} from '../../../models/Yoga';


// Custom audio player component
const AudioPlayer = ({ url }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = React.createRef();

  useEffect(() => {
    if (isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
      audioRef.current.currentTime = 0; // Reset playback time
    }
  }, [isPlaying, url]);

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };


  return (
    <div>

      <audio ref={audioRef} src={url} controls
        style={{
          // margin: "10px 15px", 
          padding: "8px 55px 2px 0px" /// T R B L
        }}
      />

      {/* <button onClick={handlePlayPause}>
        {isPlaying ? "Pause" : "Play"}
      </button> */}
    </div>
  );
};



// Yoga
const Yoga = () => {


  // get data
  const { data, isLoading } = useGetYogasQuery();
  const { data: languageData, languageLoading} = useGetLanguageQuery();
  const { data: categoryData, categoryLoading} = useGetYogaEmpowerCategoriesQuery();


  const [createYoga] = useCreateYogaMutation();
  const [updateYoga] = useUpdateYogaMutation();
  const [deleteYoga] = useDeleteYogaMutation();
  


  // theme
  const theme = useTheme();

  const gridApiRef = useRef(null);

  useEffect(() => {
    // Access grid API when it's ready
    if (gridApiRef.current) {
      const api = gridApiRef.current;
      // Perform any actions needed with the grid API here
      // For example, you could set initial selected rows:
      api.setSelectedRows([0]);
    }
  }, [gridApiRef]);

  // data columns
  const columns = [
    // {
    //   field: "_id",
    //   headerName: "ID",
    //   flex: 1,
    // },
    {
      field: "exerciseName",
      headerName: "Exercise Name",
      flex: 1,
      // editable: true,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
    },
     {
      field: "categoryId",
      headerName: "Category",
      flex: 1,
      renderCell: (params) => {
        console.log('Row data:', params.row); // Log the row data to check the structure
        if (params.row.categoryId && params.row.categoryId.name) {
          return params.row.categoryId.name;
        } else {
          return ''; 
        }
      }
    },


    {
      field: "languageId",
      headerName: "Language",
      flex: 1,
      renderCell: (params) => {
        console.log('Row data:', params.row); // Log the row data to check the structure
        if (params.row.languageId && params.row.languageId.name) {
          return params.row.languageId.name;
        } else {
          return ''; // or any default value you prefer
        }// Access name property from languageId
      }
    },

    {
      field: "exerciseUrl",
      // headerName: "Exercise Url",
      headerName: "Content",
      flex: 1,
      // editable: true,
      renderCell: (params) => {
        return <AudioPlayer url={params.value} />;
      },
    },
    {
      field: "exerciseDescription",
      headerName: "Exercise Description",
      flex: 1,
      // editable: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => {
        const { _id } = params.row;
        return (
          <div>
            <IconButton
              color="primary"
              aria-label="edit"
              onClick={() => handleOpenEdit(_id)}
            >
              <EditIcon sx={{ color: 'white' }} />
            </IconButton>
            <IconButton
              color="error"
              aria-label="delete"
              onClick={() => handleDeleteYoga(_id)}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const [open, setOpen] = useState(false);
  const [exerciseName, setExerciseName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [exerciseDescription, setExerciseDescription] = useState("");
  const [selectedFileType, setSelectedFileType] = useState("image/*"); // Initial file type (image)

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleFileTypeChange = (event) => {
    setSelectedFileType(event.target.value);
  };


  const [user, setUser] = useState(null);
  const [exerciseNameError, setExerciseNameError] = useState(null);
  const [categoryId, setCategoryId] = useState();
  const [languageId, setLanguageId] = useState("language");
  const [type, setType] = useState("yoga");
  const [languageError, setLanguageError] = useState(null);
  const [exerciseCategoryError, setExerciseCategoryError] = useState(null);
  const [selectedFileError, setSelectedFileError] = useState(null);
  const [exerciseDescriptionError, setExerciseDescriptionError] = useState(null);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false); // State for loading indicator
  const [selectedEditRowData, setSelectedEditRowData] = useState(null); // Add this state to store the selected row's data

  const [exerciseEditError, setExerciseEditError] = useState(null);
  const [typeError, setTypeError] = useState(null);

const typeOptions = [
"yoga", "empower"
];

  // New state to track the modified fields
  const [modifiedFields, setModifiedFields] = useState({});

  const handleExerciseNameChange = (event) => {
    setExerciseName(event.target.value);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, exerciseName: selectedEditRowData.exerciseName });
    setModifiedFields({ ...modifiedFields, exerciseName: event.target.value });

    setExerciseNameError(event.target.value ? null : "Enter exercise name");
  };

  const handleLanguageChange = (event) => {
    setLanguageId(event.target.value);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, exerciseCategory: selectedEditRowData.exerciseCategory });
    setModifiedFields({ ...modifiedFields, languageId: event.target.value });

    setLanguageError(event.target.value ? null : "Please select a language");
  };

  const handleTypeChange = (event) => {
    setType(event.target.value);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, exerciseCategory: selectedEditRowData.exerciseCategory });
    setModifiedFields({ ...modifiedFields, type: event.target.value });

    setTypeError(event.target.value ? null : "Please select a type");
  };

  const handleCategoryChange = (event) => {
    setCategoryId(event.target.value);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, exerciseCategory: selectedEditRowData.exerciseCategory });
    setModifiedFields({ ...modifiedFields, categoryId: event.target.value });

    setExerciseCategoryError(event.target.value ? null : "Please select a category");
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, selectedFile: selectedEditRowData.selectedFile });
    setModifiedFields({ ...modifiedFields, selectedFile: event.target.files[0] });

    setSelectedFileError(event.target.files.length > 0 ? null : "Select a file");
  };

  const handleExerciseDescriptionChange = (event) => {
    setExerciseDescription(event.target.value);
    // Update the modified fields
    // setModifiedFields({ ...modifiedFields, exerciseDescription: selectedEditRowData.exerciseDescription });
    setModifiedFields({ ...modifiedFields, exerciseDescription: event.target.value });

    setExerciseDescriptionError(event.target.value ? null : "Enter exercise description");
  };

  const handleAnonymousSignIn = async () => {
    try {
      // const auth = getAuth();
      const auth = getAuth(firebase);
      const userCredential = await signInAnonymously(auth);
      console.log("User signed in anonymously:", userCredential.user);
      setUser(userCredential.user);
      // Proceed with file upload (assuming user is authenticated)
    } catch (error) {
      console.error("Error signing in anonymously:", error);
      // Handle sign-in errors appropriately (e.g., display error message)
    }
  };


  const handleFileUpload = async (selectedFile) => {
    if (!selectedFile) {
      return; // Handle missing file
    }

    const storage = getStorage();
    const storageRef = ref(storage, `yoga_files/${selectedFile.name}`); // Adjust storage path as needed
    const uploadTask = uploadBytesResumable(storageRef, selectedFile);


    const promises = [
      uploadTask.on('state_changed', (snapshot) => {
        switch (snapshot.state) {
          case 'paused':
            console.log('Upload is paused');
            break;
          case 'running':
            console.log('Upload is in progress');
            break;
          default:
            break;
        }
      }),
      uploadTask.on('error', (error) => {
        console.error('Error uploading file:', error);
      }),
      uploadTask.then(async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        console.log('File uploaded successfully:', downloadURL);
        let yogaData = {
          exerciseName: exerciseName,
          
        
          type: type,
          languageId: languageId,
          exerciseUrl: downloadURL,
          exerciseDescription: exerciseDescription,
        };

        if(type === "yoga"){
          yogaData = {
            ...yogaData,
            categoryId: categoryId,
          };
        }
        await createYoga(yogaData);
      }),
    ];

    await Promise.all(promises);
  };



  const handleSubmit = async () => {
    // ... other logic

    if (!exerciseName) {
      setExerciseNameError("Enter exercise name");
      return;
    }

    // if (!categoryId) {
    //   setExerciseCategoryError("Please select a category");
    //   return;
    // }
    if(!languageId){
      setLanguageError("Please select a language");
      return;
    }

    if (!selectedFile) {
      setSelectedFileError("Select a file");
      return;
    }

    if (!exerciseDescription) {
      setExerciseDescriptionError("Enter exercise description");
      return;
    }

    setIsLoadingSubmit(true); // Start loading before asynchronous operations

    // Attempt anonymous sign-in before upload
    await handleAnonymousSignIn();

    // Upload the selected file
    await handleFileUpload(selectedFile);


    setIsLoadingSubmit(false); // Stop loading after data is created

    setOpen(false); // Close the modal after successful submission

    // // Refresh the "yogas" query after successful submission
    // useQueryClient().invalidateQueries('yogas');
    window.location.reload();
  };


  const handleOpenEdit = (id) => {
    const selectedRow = data.find((row) => row._id === id);

    if (selectedRow) {

      setExerciseName(selectedRow.exerciseName || "");

      setExerciseDescription(selectedRow.exerciseDescription || "");
      if(selectedRow.languageId){
        setLanguageId(selectedRow.languageId._id || "");
      
      }else{
        setLanguageId("");
      }
      if(selectedRow.categoryId){
        setCategoryId(selectedRow.categoryId._id || "");
      }else{
        setCategoryId("");
      }

      setSelectedEditRowData(selectedRow);

      // Set the modified fields to an empty object initially
      setModifiedFields({});

      setOpen(true);
    }
  };

  const handleEditFileUpload = async (selectedFile) => {
    if (!selectedFile) {
      return; // Handle missing file
    }

    const storage = getStorage();
    const storageRef = ref(storage, `yoga_files/${selectedFile.name}`); // Adjust storage path as needed
    const uploadTask = uploadBytesResumable(storageRef, selectedFile);

    const promises = [
      uploadTask.on('state_changed', (snapshot) => {
        switch (snapshot.state) {
          case 'paused':
            console.log('Upload is paused');
            break;
          case 'running':
            console.log('Upload is in progress');
            break;
          default:
            break;
        }
      }),
      uploadTask.on('error', (error) => {
        console.error('Error uploading file:', error);
      }),
      uploadTask.then(async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        console.log('File uploaded successfully:', downloadURL);

        const { selectedFile, ...rest } = modifiedFields;

        setModifiedFields({ ...modifiedFields, exerciseUrl: downloadURL });

        const edittedYogaData = {
          _id: selectedEditRowData._id,
          ...modifiedFields,
        };
        console.log("448 working ${edittedYogaData}", edittedYogaData);

        await updateYoga(edittedYogaData);

      }),
    ];

    await Promise.all(promises);
  };

  const handleEditSubmit = async () => {
    if (Object.keys(modifiedFields).length > 0) {

      setIsLoadingSubmit(true); // Start loading before asynchronous operations

      if (modifiedFields?.selectedFile === undefined) {
        const { selectedFile, ...rest } = modifiedFields;
        const edittedYogaData = {
          _id: selectedEditRowData._id,
          ...modifiedFields,
        };

        console.log("I 794", edittedYogaData);

        await updateYoga(edittedYogaData);

      }
      else {

      
        await handleAnonymousSignIn();


        await handleEditFileUpload(selectedFile);

      }



      setIsLoadingSubmit(false); // Stop loading after data is created

      setOpen(false); // Close the modal after successful submission

      // // Refresh the "yogas" query after successful submission

      window.location.reload();
    }
    else {
      setExerciseEditError("Edit a value first");
      return;
    }

    // Rest of the code...
  };

  const handleDeleteYoga = async (id) => {
    if (window.confirm("Are you sure you want to delete this yoga exercise?")) {
      try {
        // await deleteYoga.mutateAsync(id);
        // await deleteYoga(id);
        await deleteYoga({ id: id });
        window.location.reload(); // Reload to reflect changes in the UI
      } catch (error) {
        console.error("Error deleting yoga:", error);
      }
    }
  };

  return (
    <Box m="1.5rem 2.5rem">
      {/* Header */}
      {/* <Header title="Yoga" subtitle="List of Yoga" /> */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Audio" subtitle="List of Audio" />
        <Button variant="contained" color="primary" size="medium" onClick={handleOpen}>
          {'Add Exercise'}
        </Button>
      </Box>

      {/* Content */}
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButtom-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        {/* Grid table */}
        <DataGrid
          loading={isLoading || !data}
          getRowId={(row) => row._id}
          rows={data || []}
          columns={columns}
        // editMode="row"
        // // Handle row edit functionality (optional)
        // onRowEditCommit={({ id, ...newData }) => {
        //   // Update the edited data using the updateYoga mutation
        //   // updateYoga.mutateAsync({ id, ...newData });
        // }}
        // apiRef={gridApiRef}
        />
      </Box>


      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          minWidth: 500, // Adjust the minimum width for your modal
          p: 4, // Add padding inside the modal
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper', // Set white background
          borderRadius: 2,           // Add rounded borders (adjust the value)
          boxShadow: 24
        }}>

          <DialogContent>
            {/* Error messages */}
            {exerciseNameError && <Typography variant="caption" color="error">{exerciseNameError}</Typography>}
            {selectedFileError && <Typography variant="caption" color="error">{selectedFileError}</Typography>}
            {exerciseEditError && <Typography variant="caption" color="error">{exerciseEditError}</Typography>}

            <DialogContentText>
              {"Add a new exercise:"}
            </DialogContentText>
            {/* <TextField
              label="Exercise Name"
              value={exerciseName}
              onChange={(event) => setExerciseName(event.target.value)}
              fullWidth
              margin="normal"
            /> */}
            <TextField
              label="Exercise Name"
              value={exerciseName}
              onChange={handleExerciseNameChange}
              error={!!exerciseNameError} // Set error prop based on error state
              helperText={exerciseNameError} // Set helper text for error display
              fullWidth
              margin="normal"
            />
            <br />
            <br />
            <InputLabel sx={{ mb: 1 }}>Type</InputLabel>
            <Select
              label="Type"
              value={type}
              onChange={handleTypeChange}
              error={!!typeError}
              fullWidth
            >
                 <MenuItem value="yoga">Yoga</MenuItem>
              <MenuItem value="empower">Empower</MenuItem>
             
            </Select>
          
            <br />
            <br />
            <InputLabel sx={{ mb: 1 }}>Language</InputLabel>
            <Select
              label="Exercise Language"
              value={languageId}
              onChange={handleLanguageChange}
              error={!!languageError}
              fullWidth
            >
           

              {languageData && languageData.map((lang) => ( 
    <MenuItem key={lang._id} value={lang._id}>{lang.name}</MenuItem>
  ))}



  
           

 
            </Select>

            {type === "yoga" && (
  <>
    <br />
    <br />
    <InputLabel sx={{ mb: 1 }}>Category</InputLabel>
    <Select
      label="Exercise Category"
      value={categoryId}
      onChange={handleCategoryChange}
      error={!!exerciseCategoryError}
      fullWidth
    >
      {categoryData && categoryData.data.map((cat) => (
        <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>
      ))}
    </Select>
  </>
)}
            <br />
            <br />
            {/* <InputLabel id="demo-simple-select-label">File Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedFileType}
              label="File Type"
              onChange={handleFileTypeChange}
            >
              <MenuItem value={"image/*"}>Image</MenuItem>
              <MenuItem value={"video/*"}>Video</MenuItem>
            </Select>
            <br /> */}
            <input
              type="file"
              accept="audio/mpeg"
              onChange={handleFileChange}
            />
            <br />
            <br />
            <TextField
              label="Exercise Description"
              value={exerciseDescription}
              onChange={handleExerciseDescriptionChange}
              error={!!exerciseDescriptionError} // Set error prop based on error state
              helperText={exerciseDescriptionError} // Set helper text for error display
              fullWidth
              multiline  // Enable multiline
              rows={4}    // Set the number of rows to 4
              margin="normal"
            // InputProps={{
            //   rows: 4,
            // }}
            // minRows={4} // Set minimum rows
            // maxRows={4}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            {/* <Button onClick={handleSubmit} color="primary">
              Save
            </Button> */}

            <Button onClick={!selectedEditRowData ? handleSubmit : handleEditSubmit} color="primary" disabled={isLoadingSubmit}>
              {isLoadingSubmit ? <CircularProgress size="medium" style={{ width: 20, height: 20, color: 'white' }} /> : 'Save'}
              {/* Save */}
            </Button>

          </DialogActions>
        </Box>
      </Modal>
    </Box>
  );
};

export default Yoga;
